let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4EQ7x")).then(() => parcelRequire('kAbpZ'));